import { Component } from '@angular/core';
import { UserService } from './user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'header-profile',
  templateUrl: '../templates/header-profile.component.html',
  styleUrls: ['../styles/components/header-profile.component.less']
})
export class HeaderProfileComponent {
  constructor(
    public userService: UserService,
    private router: Router,
  ) {}

  public signIn() {
    this.router.navigate(['', {outlets: {modal: ['signin']}}]);
  }

  public async signOut(e: Event) {
    e.preventDefault();
    try {
      await this.userService.signOut();
    } catch (e) {}
  }
}
